import { localToGlobalForce } from '@scene'

export const formatLocalForce = (value: Force, domain: Domain) =>
  localToGlobalForce(value, domain).z / 1000
